import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from 'components/icons';
import type { JourneyOrdersPath } from 'store/services/types';
import { ProductImage } from '../ProductImage';

interface ExpandableProductCardProps {
  data: JourneyOrdersPath | undefined;
  selected: JourneyOrdersPath | undefined;
  setSelected: Function;
  hoverActionIndicator?: boolean;
}
export const ExpandableProductCard = ({
  data,
  selected,
  setSelected,
  hoverActionIndicator = true,
}: ExpandableProductCardProps) => {
  const isCardCurrentlySelected = selected?.id === data?.id;

  return (
    <Disclosure>
      {({ open }) => (
        <div
          onClick={() => {
            setSelected({ product: data, cardOpen: open });
          }}
          className={`ml-1.5 relative group ${
            isCardCurrentlySelected &&
            'border-2 border-segments-accent-color-1 rounded-segments-4px opacity-100'
          }`}
        >
          <Disclosure.Button
            className={` flex items-center justify-between w-full py-2 px-4 text-sm font-medium text-left text-black hover:bg-segments-gray-F8 focus:outline-none  hover:opacity-100 ${
              isCardCurrentlySelected
                ? 'bg-segments-gray-F8 rounded-segments-4px opacity-100'
                : 'opacity-50'
            }`}
          >
            <div className="flex items-start w-full space-x-3">
              <div className="w-16 h-16">
                <ProductImage
                  productId={Number(data?.id)}
                  className="object-contain w-16 h-16 bg-white rounded-lg"
                  height="64"
                  width="64"
                />
              </div>
              <div className="flex items-center justify-between flex-1 ">
                <div>
                  <p
                    className={`text-sm font-bold leading-4 whitespace-pre-line line-clamp-2 ${
                      isCardCurrentlySelected && 'text-segments-accent-color-1'
                    }`}
                  >
                    {data?.title}
                  </p>

                  <p className="mt-1.5 text-black text-opacity-50 text-segments-13px">
                    Customers: {data?.unique_customers?.toLocaleString()}
                  </p>
                </div>
                <div>
                  <ChevronUpIcon
                    className={`${
                      open ? 'transform rotate-180' : ''
                    } w-5 h-5 text-black`}
                  />
                </div>
              </div>
              {!!!isCardCurrentlySelected && hoverActionIndicator && (
                <div className="absolute inset-0 items-center justify-end hidden p-4 text-right group-hover:flex">
                  <svg
                    width="28"
                    height="28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="14" cy="14" r="14" fill="#125970" />
                    <path
                      d="M12 20l5.625-5.625L12 8.75"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
          </Disclosure.Button>
          {isCardCurrentlySelected && (
            <Disclosure.Panel
              className="px-4 pt-4 pb-2 text-sm text-gray-700"
              static
            >
              <p className="font-bold">
                Avg. time between orders:{' '}
                <span className="font-normal">
                  {Number(data?.time_lapse_mean).toFixed(0)} days
                </span>
              </p>
              <p className="font-bold">
                Most before:{' '}
                <span className="font-normal">
                  {Number(data?.time_lapse_q3).toFixed(0)} days{' '}
                </span>
              </p>
              <p className="font-bold">
                Conversion rate:{' '}
                <span className="font-normal">
                  {Number(data?.likely).toLocaleString(undefined, {
                    style: 'percent',
                  })}
                </span>
              </p>
            </Disclosure.Panel>
          )}
        </div>
      )}
    </Disclosure>
  );
};
